import { useEffect, useMemo, useState } from 'react';

import { useGetGameState, useMedia } from '@pkg/hooks';

import { type Competition } from '@app/client';

const gameStateLabels = {
    desktop: {
        single: {
            upcoming: 'Game starts in',
            open: 'Game entries close in',
            playing: 'Game closes in',
            closed: 'Winners announced in',
            ended: 'Game ended',
            loading: '...',
        },
        infinite: {
            upcoming: 'Game starts in',
            open: 'Game ends in',
            playing: 'Game closes in',
            closed: 'Round ends in',
            ended: 'Game ended',
            loading: '...',
        },
    },
    mobile: {
        single: {
            upcoming: 'Starts in',
            open: 'Entries close in',
            playing: 'Closes in',
            closed: 'Winners announced',
            ended: 'Game ended',
            loading: '...',
        },
        infinite: {
            upcoming: 'Starts in',
            open: 'Game ends in',
            playing: 'Closes in',
            closed: 'Round ends in',
            ended: 'Game ended',
            loading: '...',
        },
    },
};

export const gameTimeKeys = {
    upcoming: 'submission_starts_at',
    open: 'submission_ends_at',
    playing: 'submission_ends_at',
    closed: 'ends_at',
    ended: 'ends_at',
};

export function useGameStateContent(currentGame?: Competition) {
    const { gameState, isInfinite } = useGetGameState(currentGame);
    const showMobile = useMedia(`(max-width: 1222px)`);
    const [gameStateText, setGameStateText] = useState<string>('');

    useEffect(() => {
        setGameStateText(
            gameStateLabels[showMobile ? 'mobile' : 'desktop'][isInfinite ? 'infinite' : 'single'][gameState],
        );
    }, [showMobile, gameState, isInfinite]);

    const gameTime = useMemo((): string => {
        return currentGame?.[gameTimeKeys[gameState]] || '';
    }, [currentGame, gameState]);

    return { gameStateText, gameTime };
}
